<template>
<!-- 
  src='https://emids.near.aero/Shibboleth.sso/Login?entityID=https%3A%2F%2Ffed.erau.edu/fed/idp&target=https%3A%2F%2Femids.near.aero%2Fmain.html'
 -->
  <div>
    <b-embed
        type="iframe"
        aspect="16by9"
        src='https://emids.near.aero/Shibboleth.sso/Login?entityID=https%3A%2F%2Ffed.erau.edu/fed/idp&target=https%3A%2F%2Femids.near.aero%2Fprotected%2Findex.py'
 
        allowfullscreen
    ></b-embed>
   </div>
</template>
<script>
// import '@teamhive/capacitor-single-signon';

export default {
    

  // updated(){
  //   console.log(Vue.cookie)
  // }  
}
</script>
<style scoped>

</style>
